// ----------------------------------------------------------------------

const MuiStepConnector = {
  styleOverrides: { line: ({ theme }) => ({ borderColor: theme.vars.palette.divider }) },
};

// ----------------------------------------------------------------------

export const stepper = { MuiStepConnector };
